import { Dispatch, SetStateAction, useEffect } from 'react';
import { useInfoParamsContext } from 'contexts/infoParams';
import { IModal, Modal, ModalPosition, ModalTypes } from 'contexts/modalFunc';
import { useSearchParamsContext } from 'contexts/searchParams';
import {
  AutocompleteModalContainer,
  DetailModalContainer,
  PriceAlertFormContainer,
  SearchModalContainer,
  SimilarListContainer,
  PolicyModalContainer,
} from './container';

const ModalGroups = {
  [ModalTypes.autocomplete]: [
    Modal.ARRIVALS,
    Modal.ARRIVALS_EVERYWHERE,
    Modal.DEPARTURES,
    Modal.DEPARTURES_EVERYWHERE,
  ],
  [ModalTypes.detail]: [Modal.CARD_FARE_TYPES],
  [ModalTypes.search]: [
    Modal.CARD_FARE_TYPES,
    Modal.CALENDAR,
    Modal.FARE_CHART,
    Modal.RECOMMEND,
  ],
  [ModalTypes.similar]: [Modal.SIMILAR],
  [ModalTypes.notification]: [Modal.NOTIFICATION],
  [ModalTypes.policy]: [Modal.POLICY],
};

const ModalContainers = {
  [ModalTypes.autocomplete]: AutocompleteModalContainer,
  [ModalTypes.detail]: DetailModalContainer,
  [ModalTypes.search]: SearchModalContainer,
  [ModalTypes.similar]: SimilarListContainer,
  [ModalTypes.notification]: PriceAlertFormContainer,
  [ModalTypes.policy]: PolicyModalContainer,
};

const getModalWrapper = (modalType: Modal) => {
  const modalGroup = [
    ModalTypes.autocomplete,
    ModalTypes.detail,
    ModalTypes.search,
    ModalTypes.similar,
    ModalTypes.notification,
    ModalTypes.policy,
  ].find(t => ModalGroups[t].includes(modalType));
  return modalGroup ? ModalContainers[modalGroup] : () => null;
};

const ModalContainer = ({
  modal,
  setModal,
  isSearchBoxFixed,
}: {
  modal: IModal;
  setModal: Dispatch<SetStateAction<IModal>> | Function;
  isSearchBoxFixed?: boolean;
}) => {
  const { type: modalType, position: modalPosition } = modal;
  if (modalType === Modal.NULL) return null;

  const { searchParams } = useSearchParamsContext();
  const { setInfoParamsFromCommon } = useInfoParamsContext();

  useEffect(() => {
    if (modalPosition !== ModalPosition.RECOMMEND) {
      setInfoParamsFromCommon(searchParams);
    }
  }, [modalPosition]);

  const ModalWrapper = getModalWrapper(modalType);
  return (
    <ModalWrapper
      modalInfo={modal}
      searchParams={searchParams}
      setModal={setModal}
      isSearchBoxFixed={isSearchBoxFixed}
    />
  );
};

export default ModalContainer;
